import { ShortcutBinding } from "../ShortcutManager";

export const defaultShortcutProfile: ShortcutBinding[] = [
  { shortcut: "mod+k", commandId: "app.universalSearch" },
  { shortcut: "mod+shift+p", commandId: "app.commandPalette" },
  { shortcut: "mod+enter", commandId: "form.save" },
  { shortcut: "mod+shift+enter", commandId: "form.saveAndNew" },
  { shortcut: "esc", commandId: "ui.closePopup" },
  { shortcut: "d", commandId: "nav.dashboard", scope: "sidebarHints" },
  { shortcut: "s", commandId: "nav.sales", scope: "sidebarHints" },
  { shortcut: "p", commandId: "nav.purchase", scope: "sidebarHints" },
  { shortcut: "r", commandId: "nav.products", scope: "sidebarHints" },
  { shortcut: "c", commandId: "nav.customers", scope: "sidebarHints" },
  { shortcut: "t", commandId: "nav.reports", scope: "sidebarHints" },
];
